// extracted by mini-css-extract-plugin
module.exports = {"categoryLabel":"CheckBox_categoryLabel__3GZMa","categoryInput":"CheckBox_categoryInput__GIEUD","checkMark":"CheckBox_checkMark__2h9Jd"};